import {
  HomeIcon, PlusIcon, TrashIcon, PencilIcon, EyeIcon, MagnifyingGlassIcon,
  ArrowDownTrayIcon, ArrowUpTrayIcon, ChevronUpIcon, ChevronDownIcon,
  ChevronLeftIcon, ChevronRightIcon,
  XMarkIcon, CheckIcon, CheckCircleIcon, ExclamationTriangleIcon, 
  ExclamationCircleIcon, InformationCircleIcon,
  ShieldCheckIcon, ChartBarIcon, ClipboardDocumentCheckIcon, CubeIcon,
  QrCodeIcon, PrinterIcon, CogIcon, BellIcon, DocumentIcon, Squares2X2Icon,
  ClockIcon, CameraIcon, ArrowPathIcon, DocumentArrowDownIcon,
  DocumentChartBarIcon, FunnelIcon, ArrowsUpDownIcon,
  ClipboardDocumentListIcon, Cog6ToothIcon, Bars3BottomLeftIcon,
  DocumentTextIcon, LinkIcon, DocumentDuplicateIcon, BuildingOfficeIcon,
  TableCellsIcon, Bars3Icon, UserGroupIcon, MapPinIcon, 
  TagIcon, AdjustmentsHorizontalIcon, CircleStackIcon,
  ArrowsPointingOutIcon, ArchiveBoxIcon,
  CalendarDaysIcon, ListBulletIcon, ChartPieIcon, ShieldExclamationIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

// For Loader, we'll use ArrowPathIcon with animation
const LoaderIcon = ArrowPathIcon;

const iconMap = {
  // Navigation & UI
  Home: HomeIcon,
  Plus: PlusIcon,
  Trash: TrashIcon,
  Trash2: TrashIcon,
  Pencil: PencilIcon,
  Edit: PencilIcon,
  Edit2: PencilIcon,
  Eye: EyeIcon,
  Search: MagnifyingGlassIcon,
  Download: ArrowDownTrayIcon,
  Upload: ArrowUpTrayIcon,
  ChevronUp: ChevronUpIcon,
  ChevronDown: ChevronDownIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  X: XMarkIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  
  // Alerts & Status
  Warning: ExclamationTriangleIcon,
  AlertTriangle: ExclamationTriangleIcon,
  AlertCircle: ExclamationCircleIcon,
  Info: InformationCircleIcon,
  
  // Features
  Shield: ShieldCheckIcon,
  Chart: ChartBarIcon,
  BarChart3: ChartBarIcon,
  ClipboardCheck: ClipboardDocumentCheckIcon,
  Package: CubeIcon,
  Database: Squares2X2Icon,
  QrCode: QrCodeIcon,
  Printer: PrinterIcon,
  Cog: CogIcon,
  Bell: BellIcon,
  Document: DocumentIcon,
  Clock: ClockIcon,
  Camera: CameraIcon,
  
  // Refresh & Loading
  Refresh: ArrowPathIcon,
  RefreshCw: ArrowPathIcon,
  Loader: LoaderIcon,
  
  // Documents & Reports
  DocumentReport: DocumentArrowDownIcon,
  DocumentChart: DocumentChartBarIcon,
  FileText: DocumentTextIcon,
  FileSpreadsheet: TableCellsIcon,
  
  // Filters & Sorting
  Filter: FunnelIcon,
  Sort: ArrowsUpDownIcon,
  GripVertical: Bars3Icon,
  
  // Lists & Layout
  ClipboardList: ClipboardDocumentListIcon,
  Settings: Cog6ToothIcon,
  LayoutDashboard: Bars3BottomLeftIcon,
  Grid: Squares2X2Icon,
  
  // Links & Actions
  Link: LinkIcon,
  Copy: DocumentDuplicateIcon,
  
  // Buildings & Locations
  Building: BuildingOfficeIcon,
  MapPin: MapPinIcon,
  
  // People & Organization
  Users: UserGroupIcon,
  
  // Categories & Tags
  Layers: CircleStackIcon,
  Tag: TagIcon,
  Target: AdjustmentsHorizontalIcon,
  
  // Calendar & Lists
  Calendar: CalendarDaysIcon,
  List: ListBulletIcon,

  // Charts
  PieChart: ChartPieIcon,

  // Additional Alerts
  AlertOctagon: ShieldExclamationIcon,

  // AI
  Sparkles: SparklesIcon,

  // Misc
  Lock: ShieldCheckIcon,
  Expand: ArrowsPointingOutIcon,
  Archive: ArchiveBoxIcon,
};

export type IconName = keyof typeof iconMap;

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 24, className = '' }: IconProps) {
  const IconComponent = iconMap[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  return <IconComponent className={className} style={{ width: size, height: size }} />;
}

// Export the icon map for reference
export { iconMap };
